import { c as _c } from "react/compiler-runtime";
import { BottomSheetBody, BottomSheetHeader, Skeleton } from "@opensea/ui-kit";
export const DropPublishFlowSkeleton = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <BottomSheetHeader title="Loading..." />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<BottomSheetBody><div className="flex w-full flex-col gap-4"><Skeleton className="h-4 w-32" /><Skeleton className="h-20 w-full" /><Skeleton className="h-4 w-24" /></div></BottomSheetBody></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};